module.exports = __webpack_public_path__ + "static/img/pcmt.76d6752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pcmt.jpg
// module id = o/pu
// module chunks = 1